import { createResourceKeys } from "@/lib/resource-context";

const base = createResourceKeys("invitations");

export const invitationKeys = {
  ...base,

  myInvitations: () => ["invitations", "me"] as const,
};
